import { UseFormReturn } from "react-hook-form";
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import type { OrderFormData } from "../types";

interface CommissionTabProps {
  form: UseFormReturn<OrderFormData>;
  commissionAmount: number;
}

export function CommissionTab({ form, commissionAmount }: CommissionTabProps) {
  const commissionType = form.watch("commission_type");
  const commissionValue = form.watch("commission_value");

  return (
    <div className="space-y-4">
      <FormField
        control={form.control}
        name="commission_type"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Provisiotyyppi</FormLabel>
            <Select onValueChange={field.onChange} value={field.value}>
              <FormControl><SelectTrigger><SelectValue placeholder="Valitse provisiotyyppi" /></SelectTrigger></FormControl>
              <SelectContent>
                <SelectItem value="percentage">Prosentti</SelectItem>
                <SelectItem value="fixed">Kiinteä summa</SelectItem>
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="commission_value"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Provisioarvo {commissionType === "percentage" ? "(%)" : "(€)"}</FormLabel>
            <FormControl>
              <Input type="number" min="0" step="0.01" {...field} onChange={(e) => field.onChange(parseFloat(e.target.value) || undefined)} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      {commissionType && commissionValue && (
        <div className="border rounded-lg p-4 bg-muted">
          <div className="flex justify-between items-center">
            <span className="text-sm font-medium">Laskettu provisio:</span>
            <span className="text-lg font-bold">{commissionAmount.toFixed(2)} €</span>
          </div>
        </div>
      )}
    </div>
  );
}
